function EvidenceLevel() {
  return (
    <div>
      <li className="bullet-item">
        The Evidence Level (EL) is a metric used by ClinGen and GenCC that measures the strength of evidence
        of a gene-disease relationship that correlates to a qualitative classification:
        <i>
          “Definitive”, “Strong”, “Moderate”, “Limited”, “Disputed”, “Refuted”, “Animal model only”,</i> or <i>“No
          known disease relationship”
        </i>
        . GDAs that have been reported by ClinGen or GenCC will have their corresponding Evidence Level.
      </li>
    </div>
  );
}

export default EvidenceLevel;
